module.exports = __webpack_public_path__ + "img/117.6c44fd9f.jpg";